import o from "styled-components";
import t from "../../../utils/colors.js";
import { Label as a } from "../../AutoComplete/styled.js";
const r = o.div``, e = o(r)`
  display: flex;
  flex-direction: column;
`, i = o(r)`
  margin-bottom: 17px;
`, c = o(e)``, l = o(r)`
  margin-top: 8px;
`, d = o(r)`
  margin-bottom: 24px;
`, m = o.a`
  text-decoration: underline;
  font-size: 16px;
  font-weight: 500;
  color: ${t.orange};
`, g = o.a``, x = o(r)`
  margin: 8px 0;
`, b = o(a)`
  display: block;
  margin-bottom: 8px;
`;
export {
  d as BackToManualAddressLinkWrapper,
  r as BaseWrapper,
  c as DetailsWrapper,
  g as GoBackToAutoWrapper,
  i as HeadingWrapper,
  x as InputContainer,
  b as Label,
  l as ManualAddressLinkWrapper,
  m as ToggleAddressMode,
  e as Wrapper
};
